import { Toaster, ToastBar, type Toast } from 'react-hot-toast'

const ACCENT_BY_TYPE: Record<Toast['type'], string> = {
  error: 'bg-red-500',
  success: 'bg-emerald-500',
  loading: 'bg-blue-500',
  blank: 'bg-gray-500',
  custom: 'bg-gray-500',
}

const BORDER_BY_TYPE: Record<Toast['type'], string> = {
  error: 'border-l-red-500',
  success: 'border-l-emerald-500',
  loading: 'border-l-blue-500',
  blank: 'border-l-gray-400',
  custom: 'border-l-gray-400',
}

const DEFAULT_DURATION = 5000

export function AppToaster(): JSX.Element {
  return (
    <Toaster
      position="top-right"
      gutter={10}
      containerStyle={{ zIndex: 99999, top: 16, right: 16 }}
      toastOptions={{
        duration: DEFAULT_DURATION,
        error: { duration: 7000 },
        success: { duration: 5000 },
        style: {
          padding: 0,
          borderRadius: '10px',
          background: '#ffffff',
          boxShadow: '0 20px 40px -8px rgba(15, 23, 42, 0.18), 0 6px 12px -4px rgba(15, 23, 42, 0.08)',
          maxWidth: '420px',
        },
      }}
    >
      {(t) => (
        <ToastBar
          toast={t}
          style={{
            ...t.style,
            padding: 0,
            overflow: 'hidden',
            animation: t.visible
              ? 'app-toast-in 240ms cubic-bezier(0.21, 1.02, 0.73, 1) forwards'
              : 'app-toast-out 200ms ease-in forwards',
          }}
        >
          {({ icon, message }) => {
            const duration = typeof t.duration === 'number' && Number.isFinite(t.duration)
              ? t.duration
              : DEFAULT_DURATION
            const accent = ACCENT_BY_TYPE[t.type] ?? 'bg-gray-500'
            const border = BORDER_BY_TYPE[t.type] ?? 'border-l-gray-400'
            return (
              <div className={`relative flex w-full items-start gap-3 border-l-4 ${border} bg-white px-4 py-3`}>
                <div className="mt-0.5 flex-shrink-0">{icon}</div>
                <div className="flex-1 text-[13px] leading-snug text-gray-900">{message}</div>
                <span
                  aria-hidden="true"
                  className={`pointer-events-none absolute bottom-0 left-0 h-[3px] w-full origin-left ${accent}`}
                  style={{
                    animation: `app-toast-progress ${duration}ms linear forwards`,
                  }}
                />
              </div>
            )
          }}
        </ToastBar>
      )}
    </Toaster>
  )
}
